<template>
  <div class="notice-box center-content-border">
    <h3>公告</h3>
    <div class="content">
      <el-carousel trigger="click" v-if="list&&list.length" arrow="never">
        <el-carousel-item v-for="item in list" :key="item.id">
          <el-image
            :key="item.id"
            :src="item.adImageUrl"
            fit="cover"
            @click="toDetail(item.adUrl)"
            ></el-image>
            <h2>
              <span class="ellipsis">{{item.title}}</span>
            </h2>
        </el-carousel-item>
      </el-carousel>
      <div class="no-result" v-else>暂无数据</div>
    </div>
  </div>
</template>

<script>
import { getNoticeList } from '@/util/api'
export default {
  data() {
    return {
      list: []
    }
  }, 
  mounted() {
    this.getList()
  },
  methods: {
    // 跳转详情页
    toDetail(adUrl) {
      window.open(adUrl)
    },
    getList() {
      let params = {
        pageNo: 1,
        limit: 20
      }
      getNoticeList(params).then(res => {
        if(res.code == 0) {
          this.list = res.data.filter(item => {return item.id !== 2022}) || []
          this.$emit('getImgUrl', res.data.find(item => {return item.id === 2022}))
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.notice-box{ 
  margin: 0 14px 10px 0; 
  .el-image{
    min-height:236px;
    height: 29.25vh;
    width:100%;
    cursor: pointer;
  }
  h2{
    height: 39px;
    line-height: 39px;
    width: calc(100% - 20px);
    position: absolute;
    bottom: 0;
    left: 0;
    background: rgba(0,0,0,0.50);
    font-weight: normal;
    font-size: 14px;
    color: #FFFFFF;
    padding:0 10px;
    span{
      display:inline-block;
      width: 70%;
    }
  }
  .content{
    min-height:236px;
    height: 29.25vh;
  }
}
/deep/ .el-carousel{
  position: relative;
  min-height:236px;
  height: 29.25vh;
  .el-carousel__container{
    min-height:236px;
    height: 29.25vh;
  }
  /deep/ .el-carousel__indicators--horizontal{
    transform: none;    
    padding-bottom: 10px;
    width: 49%;
    text-align: right;
    padding-right: 10px;
    .el-carousel__button{
      width: 10px;
      height: 10px;
      border-radius: 50%;
    } 
  } 
  .el-carousel__indicator--horizontal{
    padding: 0;
    padding-right: 6px;
  }
}
</style>
